const CHANGE_CLIENT_PASSWORD_SCHEMA = schema
  .object({
    new_password: schema
      .string({
        required_error: localeValidation().required,
      })
      .min(8, {
        message: localeStringReplacement(localeValidation().lengthMin, {
          items: localeValidation().characters,
          length: "8",
        }),
      }),
    new_password_repeat: schema
      .string({
        required_error: localeValidation().required,
      })
      .min(8, {
        message: localeStringReplacement(localeValidation().lengthMin, {
          items: localeValidation().characters,
          length: "8",
        }),
      }),
    old_password: schema
      .string()
      .min(8, {
        message: localeStringReplacement(localeValidation().lengthMin, {
          items: localeValidation().characters,
          length: "8",
        }),
      })
      .nullish(),
  })
  .superRefine(({ new_password, new_password_repeat }, { addIssue }) => {
    if (new_password && new_password_repeat && new_password !== new_password_repeat) {
      addIssue({
        code: "custom",
        message: localeStringReplacement(localeRuValidate.fieldsMatch, {
          fields: localeValidation().passwords,
        }),
        path: ["new_password_repeat"],
      });

      addIssue({
        code: "custom",
        message: localeStringReplacement(localeRuValidate.fieldsMatch, {
          fields: localeValidation().passwords,
        }),
        path: ["new_password"],
      });
    }
  });

type ChangeClientPasswordSchemaInfer = SchemaInfer<typeof CHANGE_CLIENT_PASSWORD_SCHEMA>;

type ChangeClientPasswordFields = FormFields<ChangeClientPasswordSchemaInfer>;

type ChangeClientPasswordForm = ChangeClientPasswordMutationVariables;

export { CHANGE_CLIENT_PASSWORD_SCHEMA };
export type { ChangeClientPasswordFields, ChangeClientPasswordForm };
